import { SVGProps } from 'react'

const RevenueSplitIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 0H12L16 16L20 0Z" fill="currentColor" />
    <path
      d="M24 8C24 8 16 16 16 24C16 16 8 8 8 8H0C0 8 12 16 12 32H20C20 16 32 8 32 8H24Z"
      fill="currentColor"
    />
  </svg>
)

export default RevenueSplitIcon
